import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import {
  StateService,
  ToolService,
  RouterService,
  Machine,
  NodeItem,
} from 'projects/shared/src/public-api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lib-machine-detail',
  templateUrl: './machine-detail.component.html',
  styleUrls: ['./machine-detail.component.scss'],
  standalone: false,
})
export class MachineDetailComponent implements OnInit {
  paramId: string;
  machine: Machine;
  subs: Subscription[] = [];
  profilePicture: Blob | File | null;
  profilePictureNodeItem: NodeItem;
  machineDocuments: NodeItem[] = [];

  constructor(
    public state: StateService,
    public route: ActivatedRoute,
    public tools: ToolService,
    public modalCtrl: ModalController,
    public routerService: RouterService
  ) {}

  ngOnInit() {
    this.subs.push(
      this.state.machines$.subscribe((x) => {
        this.machine = x.find((x) => x.id == this.paramId);
      })
    );
    this.subs.push(
      this.state.nodeItems$.subscribe((x) => {
        this.machineDocuments = x.filter(
          (x) => x.machineId == this.paramId && !x.isProfilePicture
        );
        this.profilePictureNodeItem = x.find(
          (x) => x.machineId === this.paramId && x.isProfilePicture
        );
        if (this.profilePictureNodeItem) {
          this.state
            .downloadPreviewImage(this.profilePictureNodeItem.id)
            .subscribe((content) => {
              this.profilePicture = content;
            });
        }
      })
    );
  }

  ngOnDestroy() {
    this.subs.forEach((x) => x?.unsubscribe());
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }
  edit() {
    this.modalCtrl.dismiss('edit', 'confirm');
  }

  async delete() {
    await this.modalCtrl.dismiss('delete', 'confirm');
    await this.state.deleteMachine(this.machine.id);
  }

  async openFile() {
    if (!this.profilePictureNodeItem) return;
    await this.state.openFile(this.profilePictureNodeItem.id, 'document', true);
  }
}
